import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const StethoscopeOutline = createIcon({
  displayName: 'StethoscopeOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M10,4h1a1,1,0,0,1,1,1V9a5,5,0,0,1-5,5H7A5,5,0,0,1,2,9V5A1,1,0,0,1,3,4H4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="20"
        cy="17"
        r="2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,15V10.5A2.5,2.5,0,0,0,17.5,8h0A2.5,2.5,0,0,0,15,10.5V17a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4l.00006-3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const StethoscopeTwoTone = createIcon({
  displayName: 'StethoscopeTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <path
          d="M10,4h1a1,1,0,0,1,1,1V9a5,5,0,0,1-5,5H7A5,5,0,0,1,2,9V5A1,1,0,0,1,3,4H4"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <Box
          as="circle"
          cx="20"
          cy="17"
          r="2"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M20,15V10.5A2.5,2.5,0,0,0,17.5,8h0A2.5,2.5,0,0,0,15,10.5V17a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4l.00006-3"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </Box>
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const Stethoscope: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={StethoscopeTwoTone} {...props} />
  default:
    return <CustomIcon as={StethoscopeOutline} {...props} />
  }
}

export default memo(Stethoscope)
